const formatTelefone = (telefone) => telefone.replace(/(^0?\d{2})(\d{4})(\d{4})/, '($1)$2-$3');

export default formatTelefone;